import { loadDealsList } from './deals.store';
import { checkStoreStatus } from '@/util/util.jsx';
import store from '@/store/store';

export function getDealListWrapper(type, cacheTime = 'INF') {
  if (!checkStoreStatus(type, type, loadDealsList, cacheTime)) {
    return undefined;
  }
  return store
    .getState()
    .getIn(['data', 'deals', 'list', type]);
}

export function getDealFromListWrapper(type, id, cacheTime = 'INF') {
  if (!checkStoreStatus(type, type, loadDealsList, cacheTime)) {
    return undefined;
  }
  return store
    .getState()
    .getIn(['data', 'deals', 'list', type])
    .find(deal => deal.get('id') == id);
}
